module.exports = __webpack_public_path__ + "static/media/map-marked.e73b935d.svg";